import type { Article, AuthorPage } from '../types/content'

/** Every published byline, reverse chronological. */
export const articles: Article[] = [
  {
    date: '2026',
    outlet: 'thenextweb',
    outletLabel: 'The Next Web',
    title: 'The Question AI Providers Hope VPs of Engineering Never Ask',
    url: 'https://thenextweb.com/news/the-question-ai-providers-hope-vps-of-engineering-never-ask',
  },
  {
    date: '2026',
    outlet: 'thenextweb',
    outletLabel: 'The Next Web',
    title: "Engineering's AI Reality Check",
    url: 'https://thenextweb.com/news/engineerings-ai-reality-check',
  },
  {
    date: '2026.04.17',
    outlet: 'techcrunch',
    outletLabel: 'TechCrunch',
    title: 'Tokenmaxxing Is Making Developers Less Productive Than They Think',
    url: 'https://techcrunch.com/2026/04/17/tokenmaxxing-is-making-developers-less-productive-than-they-think/',
  },
  {
    date: '2025.03.18',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: 'The Hidden Costs of Poor Developer Experience, and How to Fix Them',
    url: 'https://www.forbes.com/councils/forbestechcouncil/2025/03/18/the-hidden-costs-of-poor-developer-experience-and-how-to-fix-them/',
  },
  {
    date: '2025.02.18',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: 'Build vs. Buy: Determining Which Approach Is Right for Your Company',
    url: 'https://www.forbes.com/councils/forbestechcouncil/2025/02/18/build-vs-buy-determining-which-approach-is-right-for-your-company/',
  },
  {
    date: '2025.01.09',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: 'AI Agents in SEI: Redefining Engineering Intelligence for the Modern Age',
    url: 'https://www.forbes.com/councils/forbestechcouncil/2025/01/09/ai-agents-in-sei-redefining-engineering-intelligence-for-the-modern-age/',
  },
  {
    date: '2024',
    outlet: 'hackernoon',
    outletLabel: 'HackerNoon',
    title: 'What Are SEIPs? The New Way Engineering Leaders Measure Successful AI Adoption',
    url: 'https://hackernoon.com/what-are-seips-the-new-way-engineering-leaders-measure-successful-ai-adoption',
  },
  {
    date: '2024.05.31',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: 'How Engineering Leaders Can Achieve a Balanced View of Team Success',
    url: 'https://www.forbes.com/councils/forbestechcouncil/2024/05/31/how-engineering-leaders-can-achieve-a-balanced-view-of-team-success/',
  },
  {
    date: '2024.05.01',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: 'How to Cultivate a Culture of Continuous Learning for Enhanced DX and More',
    url: 'https://www.forbes.com/sites/forbestechcouncil/2024/05/01/how-to-cultivate-a-culture-of-continuous-learning-for-enhanced-dx-and-more/',
  },
  {
    date: '2024.04.16',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: 'AI as a Partner in Leadership: How Engineering Managers Can Benefit',
    url: 'https://www.forbes.com/councils/forbestechcouncil/2024/04/16/ai-as-a-partner-in-leadership-how-engineering-managers-can-benefit/',
  },
  {
    date: '2024.01.28',
    outlet: 'techcrunch',
    outletLabel: 'TechCrunch',
    title: 'Startups Must Strategize and Budget for AI-Assisted Software Development',
    url: 'https://techcrunch.com/2024/01/28/startups-must-strategize-and-budget-for-ai-assisted-software-development-in-2024/',
  },
  {
    date: '2023.11.04',
    outlet: 'techcrunch',
    outletLabel: 'TechCrunch',
    title: 'How Engineering Leaders Can Use AI to Optimize Performance',
    url: 'https://techcrunch.com/2023/11/04/how-engineering-leaders-can-use-ai-to-optimize-performance/',
  },
  {
    date: '2023.10.05',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: 'SPACE Framework in Enterprise DX Initiatives',
    url: 'https://www.forbes.com/councils/forbestechcouncil/2023/10/05/space-framework-in-enterprise-dx-initiatives/',
  },
  {
    date: '2023.09.15',
    outlet: 'devops',
    outletLabel: 'DevOps.com',
    title: 'Why Enterprises Should Embrace Data-Driven Software Management',
    url: 'https://devops.com/why-enterprises-should-embrace-data-driven-software-management/',
  },
  {
    date: '2023.06.30',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: 'The Dynamic Duo: How DORA Metrics and the SPACE Framework Can Transform Your Business',
    url: 'https://www.forbes.com/councils/forbestechcouncil/2023/06/30/the-dynamic-duo-how-dora-metrics-and-space-framework-can-transform-your-business/',
  },
  {
    date: '2023.04.13',
    outlet: 'techcrunch',
    outletLabel: 'TechCrunch',
    title: "Track the Right Metrics to Improve Your Developers' Work Experience",
    url: 'https://techcrunch.com/2023/04/13/track-the-right-metrics-to-improve-your-developers-work-experience/',
  },
  {
    date: '2023.03.01',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: 'Sprint Planning Tips and Tricks for Software Development Leaders',
    url: 'https://www.forbes.com/councils/forbestechcouncil/2023/03/01/sprint-planning-tips-and-tricks-for-software-development-leaders/',
  },
  {
    date: '2022.12.16',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: 'The SPACE Framework for Software Developer Productivity',
    url: 'https://www.forbes.com/councils/forbestechcouncil/2022/12/16/the-space-framework-for-software-developer-productivity/',
  },
  {
    date: '2022.11.07',
    outlet: 'forbes',
    outletLabel: 'Forbes',
    title: "Software Project Planning: An Expert's Guide",
    url: 'https://www.forbes.com/councils/forbestechcouncil/2022/11/07/software-project-planning-an-experts-guide/',
  },
  {
    date: '2022.09.09',
    outlet: 'techcrunch',
    outletLabel: 'TechCrunch',
    title: 'Use DORA Metrics to Support the Next Generation of Remote-Work Models',
    url: 'https://techcrunch.com/2022/09/09/use-dora-metrics-to-support-the-next-generation-of-remote-work-models/',
  },
  {
    date: '2021',
    outlet: 'hackernoon',
    outletLabel: 'HackerNoon',
    title: 'Increasing Engineering Efficiency with Software Development Analytics',
    url: 'https://hackernoon.com/increasing-engineering-efficiency-with-software-development-analytics',
  },
  {
    date: '2021.08.17',
    outlet: 'techcrunch',
    outletLabel: 'TechCrunch',
    title: 'Insider Hacks to Streamline Your SOC 3 Certification Application',
    url: 'https://techcrunch.com/2021/08/17/insider-hacks-to-streamline-your-soc-3-certification-application/',
  },
  {
    date: '2021.05.10',
    outlet: 'techcrunch',
    outletLabel: 'TechCrunch',
    title: 'Four Lessons I Learned About Getting Into Y Combinator, After 13 Applications',
    url: 'https://techcrunch.com/2021/05/10/4-lessons-i-learned-about-getting-into-y-combinator-after-13-applications/',
  },
  {
    date: '2021.02.08',
    outlet: 'fortune',
    outletLabel: 'Fortune',
    title:
      'Zoom Fatigue: Why Fewer Meetings and Better Data Make for Better Leadership',
    url: 'https://fortune.com/2021/02/08/zoom-fatigue-fewer-meetings-data-analytics-leadership-advice/',
  },
  {
    date: '2021.02.02',
    outlet: 'builtin',
    outletLabel: 'Built In',
    title: 'Insecure Managers Spy. Caring Managers Seek Insight.',
    url: 'https://builtin.com/authors/alex-circei',
  },
  {
    date: '2021.02.01',
    outlet: 'fastcompany',
    outletLabel: 'Fast Company',
    title:
      'Why Workplace Surveillance Is the Wrong Answer for Remote and Hybrid Teams',
    url: 'https://www.fastcompany.com/90615667/unethical-workplace-surveillance-remote-work-offices',
  },
  {
    date: '2020.12.24',
    outlet: 'techcrunch',
    outletLabel: 'TechCrunch',
    title: "Use Git Data to Optimize Your Developers' Annual Reviews",
    url: 'https://techcrunch.com/2020/12/24/reading-between-the-lines-how-data-will-optimize-your-developers-annual-reviews/',
  },
  {
    date: '2020.12.08',
    outlet: 'builtin',
    outletLabel: 'Built In',
    title: 'Why 2022 Will Be the Year of Git Analytics',
    url: 'https://builtin.com/authors/alex-circei',
  },
  {
    date: '2020.11.22',
    outlet: 'hackernoon',
    outletLabel: 'HackerNoon',
    title: 'Six Basic Tips to Reduce Software Development Costs',
    url: 'https://hackernoon.com/six-basic-tips-to-reduce-software-development-costs-ou7q3wqd',
  },
  {
    date: '2020.09.15',
    outlet: 'techcrunch',
    outletLabel: 'TechCrunch',
    title: 'If You Care About Remote Employees, Start Tracking Their Performance',
    url: 'https://techcrunch.com/2020/09/15/if-you-care-about-remote-employees-start-tracking-their-performance/',
  },
  {
    date: '2020.06.21',
    outlet: 'hackernoon',
    outletLabel: 'HackerNoon',
    title: '3 Things Great Engineering Managers Do',
    url: 'https://hackernoon.com/3-things-great-engineering-managers-do-v8w3u2c',
  },
  {
    date: '2020',
    outlet: 'hackernoon',
    outletLabel: 'HackerNoon',
    title: 'The ROI of Git Analytics Tools',
    url: 'https://hackernoon.com/the-roi-of-git-analytics-tools-181u3ynv',
  },
  {
    date: '2016',
    outlet: 'hackernoon',
    outletLabel: 'HackerNoon',
    title: 'How to Hack the Time',
    url: 'https://hackernoon.com/how-to-hack-the-time-d96497c2b0c6',
  },
]

export const authorPages: AuthorPage[] = [
  { label: 'TechCrunch', url: 'https://techcrunch.com/author/alex-circei/' },
  {
    label: 'Forbes',
    url: 'https://www.forbes.com/councils/forbestechcouncil/people/alexcircei/',
  },
  { label: 'DevOps.com', url: 'https://devops.com/author/alex-circei/' },
  { label: 'HackerNoon', url: 'https://hackernoon.com/u/alex.circei' },
  { label: 'Built In', url: 'https://builtin.com/authors/alex-circei' },
]
